import { createStore } from "vuex"

export default createStore({
  state: {
    Carts: {}// 购物车

  },
  mutations: {
    updateCart (state, carts) {
      state.Carts = carts.carts
    }
  },
  actions: {},
  modules: {}
})
